<template>
  <div class="page">
    <PullRefresh v-model="refreshing" @refresh="onRefresh" :pulling-text="'下拉刷新'" :loosing-text="'松开刷新'">
      <van-list
          :finished="finished"
          :finished-text="finishedText"
          v-model:loading="loading"
          @load="loadMore"
      >
        <div class="order-card" v-for="(order,index) in orderList" :key="order.orderNo">
          <div class="shop-name">
            {{order.shopName}}
          </div>
          <div class="text-line">
            <div class="line-title">
              订单编号：
            </div>
            <div class="line-text">
              {{order.orderNo}}
              <copy-btn style="padding-left: 5px" :text="order.orderNo"/>
            </div>
          </div>
          <div class="text-line">
            <div class="line-title">
              下单时间：
            </div>
            <div class="line-text">
              {{order.createTimeStr}}
            </div>
          </div>
          <div class="text-line" v-if="checkShowMoney(order.invoiceMoney)">
            <div class="line-title">
              开票金额：
            </div>
            <div :class="{'line-text':true, 'invoiceMoney':true,'invoiceMoney-tea':isTea}">
              ¥{{order.invoiceMoney}}
            </div>
          </div>
          <div class="divider-line" v-if="order.remark"/>
          <div class="order-remark" v-if="order.remark">
            {{order.remark}}
          </div>
        </div>
      </van-list>
    </PullRefresh>
  </div>
</template>

<script>
import {invoiceTaskOrder} from "@/api/invoice";
import {PullRefresh} from "vant";
import {isCottiApp, setPageTitle} from "@/utils";
import CopyBtn from "@/views/invoice/components/copy-btn.vue";

export default {
  name: "orders",
  components: {CopyBtn, PullRefresh},
  computed: {
    isTea() {
      return window.location.host.includes('teacat');
    },
  },
  data() {
    return {
      token: this.$route.query.token,
      refreshing: false,
      loading: false,
      finished: true,
      finishedText: '',
      invoiceNo: null,
      pageNo: 1,
      pageSize: 10,
      orderList: [],
    };
  },
  mounted() {
    this.invoiceNo = this.$route.query.invoiceNo;
    this.$toast.loading({message: '加载中...',forbidClick: true})
    setPageTitle('发票相关订单')
    this.getOrderList();
  },
  methods: {
    checkShowMoney(m) {
      if (m === null || m === undefined) {
        return false;
      } else {
        return m >= 0;
      }
    },
    getOrderList() {
      invoiceTaskOrder({
        invoiceNo: this.invoiceNo,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then(res => {
        this.finished = res.data.length < this.pageSize;
        if (this.pageNo === 1) {
          this.orderList = res.data;
          this.finishedText = '';
        } else {
          this.orderList = [...this.orderList, ...res.data];
          this.finishedText = '没有更多了';
        }
        this.loading = false;
        this.refreshing = false;
      }).catch(err => {
        console.log(err)
        this.finished = true;
      }).finally(() => {
        this.loading = false;
        this.refreshing = false;
      });
    },
    onRefresh() {
      console.log('onRefresh')
      this.pageNo = 1;
      this.refreshing = true;
      this.getOrderList()
    },
    loadMore() {
      console.log('loadMore')
      this.pageNo++;
      this.getOrderList()
    },
  },
}
</script>


<style scoped lang="scss">
.page{
  height: 100vh;
  background-color: #F5F5F5;
  overflow-y: scroll;
  //overflow-x: scroll;
}

.order-card {
  background-color: white;
  margin: 24px 32px;
  //padding: 12px 16px 12px 12px;
  padding: 24px;
  border-radius: 20px;
  overflow: hidden;
  .shop-name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 26px;
    color: #3A3B3C;
    line-height: 36px;
    text-align: left;
    font-style: normal;
    max-lines: 2;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .text-line {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 16px;
    .line-title{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #ACACAC;
      line-height: 32px;
      text-align: left;
      font-style: normal;
    }
    .line-text{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #3A3B3C;
      line-height: 32px;
      text-align: left;
      font-style: normal;

      display: flex;
      flex-direction: row;

    }
    .invoiceMoney{
      font-weight: 500;
      color: #A52337;
    }
    .invoiceMoney-tea {
      font-weight: 500;
      color: #2A2A2A;
    }
  }
  .divider-line{
    height: 1px;
    background-color: #EEEEEE;
    margin: 0 24px;
    margin-top: 20px;

  }
  .order-remark {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #A52337;
    line-height: 32px;
    text-align: left;
    font-style: normal;
    margin-top: 18px;
  }
}

</style>
